import type { LucideProps } from 'lucide-react';
import { ChevronDown } from 'lucide-react';

export default function ChevronDownIcon(props: LucideProps) {
  return <ChevronDown {...props} />;
}
